import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Dashboard from "../components/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store";
import { getVendorUserById } from "../store/auth/authActions";
import axios from "axios";
import MyPageSection from "../components/MyPageSection";
import { api_url } from '../api/config/config';
import { useLocation, useNavigate } from "react-router-dom";
import { useApi } from "../api/contexts/ApiContext";
import { Image } from "react-bootstrap";

const sectionConfig = {
    search: { title: "最近閲覧した案件", icon: "icon-search.svg" },
    new: { title: "新着", icon: "icon-new-rotation.svg" },
    // light: { title: "おすすめ案件", icon: "recommended-icon.svg" },
    ending: { title: "期限間近", icon: "icon-process-red.svg" }
};


const MyPage: React.FC = () => {
    const { userInfo } = useSelector((state: RootState) => state.auth);
    const { vendorInfo } = useSelector((state: RootState) => state.vendor);
    const dispatch = useDispatch<AppDispatch>();
    const [opportunities, setOpportunities] = useState<any[]>([]);
    const [sections, setSections] = useState<any>({});
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialMode = queryParams.get('mode') === 'facility' ? 'facility' : 'company';
    const [mode, setMode] = useState(initialMode);
    const navigate = useNavigate();
    const { getModule } = useApi();
    useEffect(() => {
        const fetchData = async () => {
            const opportunityApi = await getModule('OpportunityApi');
            if (userInfo?.id && vendorInfo?.vendor_id) {
                const body = {
                    mode: mode,
                    user_id: userInfo.id.toString(),
                    vendor_id: vendorInfo.vendor_id,
                    conditions: null,
                    limit: 9,
                    offset: 0,
                }
                const fetchers = {
                    search: () => opportunityApi.getRecentlyViewed(body),
                    new: () => opportunityApi.getNewOpportunities(body),
                    //   light: () => fetch(`${api_url}/getRecentlyViewed`, {
                    //     method: "POST",
                    //     headers: { "Content-Type": "application/json" },
                    //     body: JSON.stringify(body),
                    //   }).then(r => r.json()),
                    ending: () => opportunityApi.getOpportunitiesEndingSoon(body),
                };

                const results = await Promise.all(
                    Object.keys(sectionConfig).map(key => fetchers[key as keyof typeof fetchers]())
                );

                const newSections: Record<string, any[]> = {};
                Object.keys(sectionConfig).forEach((key, i) => {
                    newSections[key] = (results[i] as any).data[mode] || [];
                });
                setSections(newSections);
            }
        };

        setSections({});
        fetchData();
    }, [mode, initialMode]);


    const handleModeChange = (newMode: string) => {
        setMode(newMode);
        if (newMode === 'facility') {
            navigate(`${location.pathname}?mode=facility`);
        } else {
            navigate(`${location.pathname}`);
        }
    };


    return (
        <div>
            {/* <Header mode="company" vendor={{ companyName: vendorInfo?.companyName, lastName: userInfo?.lastName, firstName: userInfo?.firstName }} /> */}
            <section className="section-1 py-lg-5 py-4 info-dispaly">
                <div className="container">
                    <div className="row mx-0 text-center mb-lg-5 mb-4">
                        <div className="col-lg-6 px-0">
                            <a href="#" onClick={() => handleModeChange("company")}>
                                <button className={`btn btn-lg btn-theme-custom-lg btn-outline-primary rounded-0 w-100 mb-3
                                 ${mode === "company" ? "active" : ""}`}>
                                    <Image className="height-35 me-2" src="assets/images/other/icon-building-crossways.svg" />企業別の情報を表示する
                                </button>
                            </a>
                        </div>
                        <div className="col-lg-6 px-0">
                            <a href="#" onClick={() => handleModeChange("facility")}>
                                <button className={`btn btn-lg btn-theme-custom-lg btn-outline-success rounded-0 w-100 mb-3
                            ${mode === "facility" ? "active" : ""}`} >
                                    <Image className="height-35 me-2" src="assets/images/other/icon-building-level.svg" />施設別の情報を表示する
                                </button>
                            </a>
                        </div>
                    </div>
                    <Dashboard mode={mode} />

                </div>
            </section>

            <div>
                {Object.entries(sectionConfig).map(([key, config]) =>
                    sections[key] && sections[key].length > 0 ? (
                        <MyPageSection
                            key={key}
                            sectionKey={key}
                            title={config.title}
                            icon={config.icon}
                            data={sections[key]}
                            mode={mode}
                        />
                    ) : null
                )}
            </div>
            <Footer />
        </div>
    );
}

export default MyPage;